import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import type { Category } from "../../API/Models";
import { client } from "../../Clients";

export interface CategoriesState {
	items: Category[];
	loading: boolean;
	isRefreshing: boolean;
	error?: string | null;
	initialized: boolean;
	lastUpdated: string | null;
}

const initialState: CategoriesState = {
	items: [],
	loading: false,
	isRefreshing: false,
	error: null,
	initialized: false,
	lastUpdated: null
};

const categoriesSlice = createSlice({
	name: "categories",
	initialState,
	reducers: {
		setLoading(state, action: PayloadAction<boolean>) {
			state.loading = action.payload;
		},
		setRefreshing(state, action: PayloadAction<boolean>) {
			state.isRefreshing = action.payload;
		},
		setCategories(state, action: PayloadAction<Category[]>) {
			state.items = action.payload ?? [];
			state.initialized = true;
			state.error = null;
			state.lastUpdated = new Date().toISOString();
		},
		setError(state, action: PayloadAction<string | null>) {
			state.error = action.payload;
			state.loading = false;
			state.isRefreshing = false;
		}
	}
});

export const { setLoading, setRefreshing, setCategories, setError } = categoriesSlice.actions;
export const { reducer } = categoriesSlice;

export const fetchCategories = (manual = false) => async (dispatch: Dispatch) => {
	if (manual) {
		dispatch(setRefreshing(true));
	} else {
		dispatch(setLoading(true));
	}
	try {
		const response = await client.categories.apiCategoriesGet();
		dispatch(setCategories(response.data ?? []));
	} catch (err: any) {
		dispatch(setError(err?.message ?? "Unable to load categories"));
	} finally {
		if (manual) {
			dispatch(setRefreshing(false));
		} else {
			dispatch(setLoading(false));
		}
	}
};
